import Axios from "axios";

import { 
  SET_VAT_REGISTER_LIST, 
  UNSET_VAT_REGISTER_LIST,
  SET_VAT_PAYMENT_RECORD,
  UNSET_VAT_PAYMENT_RECORD,
  SET_VAT_PAYMENT_DETAILS,
  UNSET_VAT_PAYMENT_DETAILS,

 } from "@/store/mutation-types";


import {
  getVatRegister as getVatRegisterApi,
  vatPayout as vatPayoutApi,
  vatPaymentList as vatPaymentListApi,
  vatChallanInfoStore as vatChallanInfoStoreApi,
  vatPaymentDetails as vatPaymentDetailsApi,
} from "@/store/api";

const state = {
  getVatRegisterList: [],
  getVatPaymentList: [],
  getVatPaymentDetails: [],
};


const getters = {
  getVatRegisterList(state) {
    return state.getVatRegisterList;
  },
  getVatPaymentList(state) {
    return state.getVatPaymentList;
  },
  getVatPaymentDetails(state) {
    return state.getVatPaymentDetails;
  },
};


// Mutations
const mutations = {
  [SET_VAT_REGISTER_LIST](state, data) {
    state.getVatRegisterList = data;
  },
  [UNSET_VAT_REGISTER_LIST](state) {
    state.getVatRegisterList = [];
  },
  [SET_VAT_PAYMENT_RECORD](state, data) {
    state.getVatPaymentList = data;
  },
  [UNSET_VAT_PAYMENT_RECORD](state) {
    state.getVatPaymentList = [];
  },
  [SET_VAT_PAYMENT_DETAILS](state, data) {
    state.getVatPaymentDetails = data;
  },
  [UNSET_VAT_PAYMENT_DETAILS](state) {
    state.getVatPaymentDetails = [];
  },
};

// Actions
const actions = {

getVatPaymentDetails({ commit }, data) {
  commit("SET_LOADING", { color: "primary" });
  return new Promise((resolve, reject) => {
    Axios.get(`${vatPaymentDetailsApi}`, { params: data })
      .then((response) => {
        commit(SET_VAT_PAYMENT_DETAILS, response.data || {});
        resolve(response);
      })
      .catch((error) => {
        commit(UNSET_VAT_PAYMENT_DETAILS);
        reject(error);
      })
      .finally(() => {
        commit("UNSET_LOADING");
      });
  });
},


  getVatRegisterList({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });

    return new Promise((resolve, reject) => {
      Axios.get(`${getVatRegisterApi}`, { params: data })
        .then((response) => {
          commit(SET_VAT_REGISTER_LIST, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_VAT_REGISTER_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getVatPaymentList({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });

    return new Promise((resolve, reject) => {
      Axios.get(`${vatPaymentListApi}`, { params: data })
        .then((response) => {
          commit(SET_VAT_PAYMENT_RECORD, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_VAT_PAYMENT_RECORD);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  storeVatPayout({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(vatPayoutApi, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  storeVatChallanInfo({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(vatChallanInfoStoreApi, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

};


export default {
  state,
  getters,
  actions,
  mutations,
};